import { Box } from '@mui/material';
import { useStyles } from './SessionMedications.styles';
import LottieMedications from '../../../../../../icons/lotties/lottieIcons/LottieMedications';
import { MedicationSection } from '../../../../../../../pages/provider/sessions/sign-off-v4/sections/MedicationSection';

const SessionMedications = ({
  appointment,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.welcomeFrame}>
        <Box display="flex" flexDirection="column" flexGrow={1} flex={1} gap="4px">
          <p className={classes.sectionTitle}>
            Medications
          </p>
          <p className={classes.sectionSubtitle}>
            Prescribe directly in session
          </p>
        </Box>
        <LottieMedications className={classes.animatedIcon} />
      </Box>
      <Box flex={1} width={"100%"} p={3}>
        <MedicationSection appointment={appointment} isSession />
      </Box>
    </Box>
  );
};
export { SessionMedications };
